import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsEBikeRideNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.33 5.74l1.54-2.94H14.7V.7l-1.46 2.9h1.09zM12.46 8.35c-.31 0-.6.05-.89.13L10.24 5.4h1.72c.27 0 .49.22.49.49 0 .28.22.5.5.5s.5-.22.5-.5c0-.82-.67-1.49-1.49-1.49H9.48c-.17 0-.33.08-.42.22s-.1.32-.04.47l.76 1.78H6.85l-.66-1.48h.82c.27 0 .49-.22.49-.49s-.22-.5-.49-.5H4.04a.49.49 0 000 .98H5.1l.85 1.93-.92 1.39a3.37 3.37 0 00-1.49-.35C1.62 8.35.07 9.91.07 11.82s1.56 3.48 3.47 3.48c1.74 0 3.18-1.3 3.42-2.97H8.5c.17 0 .33-.09.42-.23.04-.06.06-.14.07-.21a3.466 3.466 0 003.47 3.41c1.92 0 3.47-1.56 3.47-3.48s-1.56-3.47-3.47-3.47zM3.54 14.3c-1.37 0-2.47-1.11-2.47-2.48a2.469 2.469 0 013.4-2.29l-1.35 2.01c-.1.15-.11.35-.03.51.09.16.26.26.44.26h2.42a2.44 2.44 0 01-2.41 1.99zm3.43-2.98H4.48l.83-1.24.56-.83.56-.85 1.29 2.92zm.32-3.45h2.92l.43 1c-.99.61-1.65 1.69-1.66 2.93 0-.06-.01-.12-.03-.18zm5.17 6.43c-1.37 0-2.47-1.11-2.47-2.48 0-.84.42-1.58 1.06-2.03l.95 2.23a.5.5 0 00.66.26c.25-.11.37-.4.26-.66l-.96-2.22a2.469 2.469 0 012.96 2.42c.01 1.37-1.1 2.48-2.46 2.48z"
  }));
});
SvgSportsEBikeRideNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsEBikeRideNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsEBikeRideNormalXsmall;